/**
 * Props accepted by {@link TaskLinkIcon}.
 */
interface TaskLinkIconProps {
  className?: string;
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
}

/**
 * Renders the chain-link icon used for link-task actions.
 *
 * @param props - Optional style and sizing props for the icon.
 * @returns SVG chain-link icon for link-task actions.
 */
const TaskLinkIcon = ({
  className,
  width = 20,
  height = 20,
  stroke = "black",
  strokeWidth = 0.8,
}: TaskLinkIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M8.00328 10.3992C8.34685 10.8585 8.78517 11.2385 9.28852 11.5135C9.79188 11.7885 10.3485 11.9521 10.9206 11.9931C11.4927 12.034 12.067 11.9515 12.6044 11.751C13.1418 11.5505 13.6298 11.2368 14.0353 10.8312L16.4353 8.43119C17.1639 7.67678 17.5671 6.66637 17.558 5.61759C17.5489 4.5688 17.1282 3.56555 16.3866 2.82392C15.6449 2.08228 14.6417 1.66161 13.5929 1.65249C12.5441 1.64338 11.5337 2.04656 10.7793 2.77519L9.40328 4.14319M11.2033 8.79919C10.8597 8.33989 10.4214 7.95985 9.91804 7.68484C9.41469 7.40983 8.85808 7.2463 8.28596 7.20532C7.71385 7.16435 7.13962 7.2469 6.60221 7.44737C6.0648 7.64783 5.57679 7.96153 5.17128 8.36719L2.77128 10.7672C2.04265 11.5216 1.63948 12.532 1.64859 13.5808C1.6577 14.6296 2.07838 15.6328 2.82001 16.3745C3.56164 17.1161 4.56489 17.5368 5.61368 17.5459C6.66247 17.555 7.67288 17.1518 8.42728 16.4232L9.79528 15.0552"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TaskLinkIcon;
